import { get, noop } from 'lodash'
import React, { SyntheticEvent } from 'react'
import { Dropdown, DropdownProps } from 'react-bootstrap'
import { Link, useHistory } from 'react-router-dom'
import styled from 'styled-components'

import TooltipTrigger from '../../../TooltipTrigger'

const DropdownWrapper = styled.div`
  font-size: 18px;
  display: flex;
  color: ${({ color }) => color};
  align-self: stretch;
  &:hover {
    background: rgba(0, 0, 0, 0.03);
  }
`
const DropdownMenu = styled.div`
  padding: 10px 0px;
  display: ${({ show }) => (show ? '' : 'hidden')};
`

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 100%;
  padding: 0 15px;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`

const Toggle = (props) => {
  const { icon, onClickCustom, tooltip, href, hrefTarget } = props

  const onClick = (e) => {
    if (onClickCustom) {
      onClickCustom(e)
    }
    if (href) {
      window.open(href, hrefTarget || '_blank')
    }
  }

  return (
    <TooltipTrigger tooltip={tooltip}>
      <ToggleWrapper onClick={onClick}>
        <i className={icon} />
      </ToggleWrapper>
    </TooltipTrigger>
  )
}

const Child = (props) => {
  const { label, icon, ...rest } = props

  const history = useHistory()

  const onClick = () => {
    if (rest.onClick) {
      rest.onClick()
      return
    }
    if (get(rest, 'to')) {
      history.push(get(rest, 'to', ''))
      return
    }
  }

  return (
    <Dropdown.Item
      {...rest}
      style={{ fontSize: '1.1em', padding: '8px 15px' }}
      as={get(rest, 'to') ? 'button' : undefined}
      onClick={onClick}
    >
      <span>
        <i className={`${icon} mr-2`} />
        {label}
      </span>
    </Dropdown.Item>
  )
}

const Item = (props) => {
  const { icon, children, onClick, tooltip, color, ...rest } = props
  return (
    <Dropdown as={DropdownWrapper} flip color={color}>
      <Dropdown.Toggle
        as="div"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'stretch',
        }}
      >
        <Toggle
          tooltip={tooltip}
          {...rest}
          icon={icon}
          onClickCustom={onClick || noop}
        />
      </Dropdown.Toggle>
      {children && (
        <Dropdown.Menu as={DropdownMenu} alignRight>
          {children
            .filter(Boolean)
            .filter((item) => item.show !== false)
            .map((child, index) => (
              <Child key={index} {...child} />
            ))}
        </Dropdown.Menu>
      )}
    </Dropdown>
  )
}
export default Item
